
<template>
  <v-card>
    <v-banner single-line>
      <v-container>
        <v-row>
          <v-col>
            <h2 class="pb-6">Reservationsanfrage</h2>
            <p><b>Anlage:</b> {{ categories[currentEvent.category] }}</p>
            <p><b>Verein:</b> {{ currentEvent.name }}</p>
            <p><b>Datum:</b> {{ datumFormatted }}</p>
            <p>
              <b>Zeitraum:</b> {{ starttimeFormatted }} - {{ endtimeFormatted }}
            </p>
          </v-col>
          <v-col>
            <h2 class="mb-4">Nachricht</h2>
            <v-textarea
              name="nachricht"
              label="Nachricht"
              v-model="message"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-banner>
    <v-card-actions v-if="currentEvent.approved == null">
      <v-container>
        <span class="mr-4">
          <v-btn
            color="error"
            :disabled="isSending"
            :loading="isSending"
            @click="manageEvent(eventId, false, token)"
            >Ablehnen</v-btn
          >
        </span>
        <span>
          <v-btn
            color="success"
            :disabled="isSending"
            :loading="isSending"
            @click="manageEvent(eventId, true, token)"
            >Anfrage annehmen</v-btn
          >
        </span>
      </v-container>
    </v-card-actions>
    <v-card-actions v-else>
      <v-container>
        <div class="edit-container">
          <span>
            <v-btn color="primary" @click="reset" class="mr-4"
              >Bearbeiten</v-btn
            >
            <v-btn color="white" @click="goHome" class="mr-4">Schliessen</v-btn>
          </span>
          <v-alert dense v-if="currentEvent.approved" type="success">
            Bestätigt
          </v-alert>
          <v-alert
            dense
            v-if="!currentEvent.approved && currentEvent.approved != null"
            type="error"
          >
            Abgelehnt
          </v-alert>
        </div>
      </v-container>
    </v-card-actions>
  </v-card>
</template>
<script>
// Mixins
import getEvent from "@/mixins/getEvent";
import eventCategories from "@/mixins/eventCategories";
import manageEvent from "@/mixins/manageEvent";

// Date
import { format } from "fecha";
import { setGlobalDateI18n } from "fecha";

setGlobalDateI18n({
  dayNames: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
  ],
});

export default {
  mixins: [getEvent, eventCategories, manageEvent],
  data() {
    return {
      ready: false,
      currentEvent: {
        category: null,
        name: "",
        start: "",
        end: "",
      },
      message: "",
      edit: true,
      isSending: false,
    };
  },
  props: {
    eventId: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
  },
  computed: {
    datumFormatted() {
      return this.ready
        ? format(new Date(this.currentEvent.start), "dddd DD.MM.YYYY")
        : this.currentEvent.start;
    },

    starttimeFormatted() {
      return this.ready
        ? format(new Date(this.currentEvent.start), "H:mm")
        : this.currentEvent.start;
    },

    endtimeFormatted() {
      return this.ready
        ? format(new Date(this.currentEvent.end), "H:mm")
        : this.currentEvent.end;
    },
  },
  mounted() {
    this.getEvent(this.eventId);
    this.ready = true;
  },
  methods: {
    reset() {
      this.currentEvent.approved = null;
      console.log(this.currentEvent);
    },
    goHome() {
      this.$router.push({ name: "Home" });
      location.reload();
    },
  },
};
</script>
<style>
.edit-container {
  display: flex;
  justify-content: space-between;
}

.edit-container .v-alert--dense {
  margin-bottom: 0;
  padding-bottom: 6px;
  padding-top: 6px;
}
</style>